import { render, staticRenderFns } from "./MergePendingRecognitionDocumentModal.vue?vue&type=template&id=311c9e7a&"
import script from "./MergePendingRecognitionDocumentModal.vue?vue&type=script&lang=js&"
export * from "./MergePendingRecognitionDocumentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCardText,VRadio,VRadioGroup})
